/**
 * One-shot, in-memory handoff of the credentials just used for a successful
 * password login, so BiometricEnrollmentGate can offer to store them.
 *
 * The gate lives at the app root and runs after the login route has already
 * unmounted, so it has no access to the form state. These values are kept in a
 * module variable on purpose: never written to redux (which is inspectable via
 * devtools), never persisted, and cleared as soon as they are read.
 */
let pendingCredentials = null

export function setPendingBiometricCredentials(credentials) {
  pendingCredentials = credentials
}

export function consumePendingBiometricCredentials() {
  const credentials = pendingCredentials
  pendingCredentials = null
  return credentials
}

export function clearPendingBiometricCredentials() {
  pendingCredentials = null
}
